import { LocalizedPlayer, PlayerRole } from "../types/player"
import { SEO } from "../types/next.js"
import { getDefaultCanonicalData } from "./canonicalization"
import { getPlayerPageUrl } from "./urls"
import { LocalizedSeasonTeamPlayer, SimplifiedSeasonTeamPlayer } from "types/seasonTeamPlayer"

export async function getPlayerPartialSEO(player: LocalizedPlayer, page: string): Promise<Partial<SEO>> {
  const partialPage = page.split("/").pop()

  if (partialPage === player.calciocomSlug!) {
    return {
      canonicals: [getPlayerPageUrl(player.calciocomSlug!)],
      index: true,
      follow: true,
    }
  } else {
    return {
      canonicals: [getPlayerPageUrl(player.calciocomSlug!)],
      index: false,
      follow: true,
    }
  }
}

export async function getPlayerCanonicalUrls(
  crawUrls: string[],
  player: LocalizedPlayer,
  page: string,
): Promise<string[]> {
  if (crawUrls.includes(page)) {
    return [page]
  }

  const partialSeo = await getPlayerPartialSEO(player, page)

  return partialSeo.canonicals!
}

export async function getPlayerCanonicalData(player: LocalizedPlayer, page: string): Promise<Partial<SEO>> {
  const defaultCanonicalData = await getDefaultCanonicalData(page)
  if (defaultCanonicalData) {
    return defaultCanonicalData
  }

  return await getPlayerPartialSEO(player, page)
}

export function playerRoleToTranslation(playerRole: PlayerRole | number, plural = false) {
  switch (playerRole) {
    case 1:
    case "goalkeeper":
      return plural ? "Portieri" : "Portiere"

    case 2:
    case "defender":
      return plural ? "Difensori" : "Difensore"

    case 3:
    case "midfielder":
      return plural ? "Centrocampisti" : "Centrocampista"

    case 4:
    case "forward":
      return plural ? "Attaccanti" : "Attaccante"
  }
}

export const simplifyTeamPlayer = (player: LocalizedSeasonTeamPlayer): SimplifiedSeasonTeamPlayer => {
  return {
    id: player.id,
    teamId: player.teamId,
    seasonId: player.seasonId,
    playerId: player.playerId,
    jerseyNumber: player.jerseyNumber,
    roleId: player.roleId,
    team: player.team,
    season: player.season,
    player: player.player,
    role: player.role,
  }
}
